// extracted by mini-css-extract-plugin
export default {"advertFooter":"W24yrXAi"};